export default __webpack_public_path__ + "static/image-new-d9f54f8bda7907b84712af40104f7112.jpg";